import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';

import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import BookingPage from './pages/BookingPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      {/* AuthProvider envolve tudo para que saibamos se o usuário está logado */}
      <AuthProvider>
        {/* Toaster para as notificações */}
        <Toaster position="top-right" />

        <Routes>
          {/* Rotas Públicas */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/agendar/:userId" element={<BookingPage />} />
          
          {/* Rota Protegida Principal */}
          {/* Qualquer rota dentro de /dashboard/* só será acessível se o usuário estiver logado */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            } 
          />
          
          {/* Rota inicial: redireciona para o login */}
          <Route path="/" element={<LoginPage />} />

        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;